/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {css, keyframes} from "emotion";
import {COLORS} from "@res/colors";

const slider = css`
	position:absolute;
	top: 0px;
	left: 0px;
  width:100%;
  height:5px;
  overflow-x: hidden;
`

const line = css`
	position:absolute;
  opacity: 0.4;
  background: ${COLORS.primary_blue};
  width:150%;
  height:5px;
`

const subLine = css`
	position:absolute;
  background: ${COLORS.primary_blue};
  height:5px;
`
const increase = keyframes`
	from { left: -5%; width: 5%; }
  to { left: 130%; width: 100%;}
`

const decrease = keyframes`
	from { left: -80%; width: 80%; }
  to { left: 110%; width: 10%;}
`

const inc = css`
	animation: ${increase} 2s infinite;
`

const dec = css`
	animation: ${decrease} 2s 0.5s infinite;
`

const hideFrame = keyframes`
	0%   {opacity: 0;}
	10%  {opacity: 1;}
	90%  {opacity: 1;}
	100% {opacity: 0;}
`

const hide = css`
	animation: ${hideFrame} 4s forwards;
`


type Props = {
	status: "loading" | "success" | "error"
}

type State = {
	show: boolean
}

export class LoadingBar
	extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			show: false
		}
	}

	componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
		if (!this.state.show && prevProps.status !== this.props.status)
			this.setState({show: true});
	}

	componentDidMount() {
		// No need to show success on mount
		if (this.props.status === "success")
			return;

		// show only loading and error
		this.setState({show: true});
	}

	render() {
		if (!this.state.show)
			return null;

		switch (this.props.status){
			case "loading":
				return <div className={slider}>
					<div className={line}/>
					<div className={`${subLine} ${inc}`}/>
					<div className={`${subLine} ${dec}`}/>
				</div>
			case "success":
				return <div className={`${slider} ${hide}`} style={{backgroundColor: COLORS.systemGreen}}/>
			case "error":
				return <div className={`${slider} ${hide}`} style={{backgroundColor: COLORS.secondary_red}}/>
			default:
				return  null;
		}
	}
}
